module.exports = __webpack_public_path__ + "img/logistic-vessel.b9574fac.png";